import React, { useState } from 'react';
import jam_screen from '../../assests/jam_screen.svg';
import healthicons from '../../assests/healthicons_doctor-male.svg';
import patient from '../../assests/Vector (3).svg';
import vector from '../../assests/Vector (4).svg';
import vector2 from '../../assests/Vector (6).svg';
import Group from '../../assests/Group 1.svg';
import flowbite from '../../assests/flowbite_command-outline.svg';
import Frame from '../../assests/Frame 1410127010.svg';
import play from '../../assests/play.svg';
import Group2 from '../../assests/Group 36689.svg';
import akar from '../../assests/akar-icons_chat-approve.svg';
import circle from '../../assests/mdi_sale-circle-outline.svg';
import users from '../../assests/ph_users-three.svg';
import carbon from '../../assests/carbon_cics-program.svg';
import question from '../../assests/question.svg';
import setting from '../../assests/tdesign_setting-1.svg';
import drPicc from '../../assests/drPicc.svg';
import Doctorr from '../../assests/Doctorr.svg';

import './sideNavbar.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function SideNavbar() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false); // State to control sidebar open/close

  const handleToggle = () => {
    setIsOpen(!isOpen); // Toggle sidebar open/close
  };

  return (
    <>
      <button className="navbar-toggle" onClick={handleToggle}>
        ☰
      </button>
      <div className={`sideNavbar col-md-2 ${isOpen ? 'open' : ''}`}>
        <nav className="nav nav-pills flex-column">
          <div className='d-flex NavTitle '>
            <img src={Group} alt="" />
            <Link to="/dashboard" className="nav-link">{t("sidebar.dashboard")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={Doctorr} alt="" />
            <Link to="/doctor" className="nav-link">{t("sidebar.doctor")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={patient} alt="" />
            <Link to="/patients" className="nav-link">{t("sidebar.patients")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={vector} alt="" />
            <Link to="/categories" className="nav-link">{t("sidebar.categories")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={vector2} alt="" />
            <Link to="/subcategories" className="nav-link">{t("sidebar.subcategories")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={jam_screen} alt="" />
            <Link to="/slider" className="nav-link">{t("sidebar.slider")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={flowbite} alt="" />
            <Link to="/services" className="nav-link">{t("sidebar.services")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={Frame} alt="" />
            <Link to="/reservation" className="nav-link">{t("sidebar.reservation")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={play} alt="" />
            <Link to="/meetings" className="nav-link">{t("sidebar.meetings")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={Group2} alt="" />
            <Link to="/treatmentPlans" className="nav-link">{t("sidebar.treatmentPlans")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={circle} alt="" />
            <Link to="/copon" className="nav-link">{t("sidebar.discountCoupons")}</Link>
          </div>
                 <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/invoices" className="nav-link">{t("invoices.title")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/ServiceCodes" className="nav-link">{t("serviceCodes.title")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/reports" className="nav-link">{t("reports.title")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/chart-of-accounts" className="nav-link">{t("sidebar.chartOfAccounts")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/journal-entries" className="nav-link">{t("sidebar.journalEntries")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/vouchers" className="nav-link">{t("accounting.vouchers.title")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/banks" className="nav-link">{t("accounting.banks.title")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/bank-accounts" className="nav-link">{t("accounting.bankAccounts.title")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/cash-registers" className="nav-link">{t("accounting.cashRegisters.title")}</Link>
       </div>
       <div className='d-flex NavTitle'>
         <img src={akar} alt="" />
         <Link to="/cost-centers" className="nav-link">{t("accounting.costCenters.title")}</Link>
       </div>
          <div className='d-flex NavTitle'>
            <img src={akar} alt="" />
            <Link to="/permissions" className="nav-link">{t("sidebar.permissions")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={users} alt="" />
            <Link to="/users" className="nav-link">{t("sidebar.users")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={carbon} alt="" />
            <Link to="/lotalyProgram" className="nav-link">{t("sidebar.loyaltyProgram")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={question} alt="" />
            <Link to="/questions" className="nav-link">{t("sidebar.faq")}</Link>
          </div>
          <div className='d-flex NavTitle'>
            <img src={setting} alt="" />
            <Link to="/settings/PublicSettings" className="nav-link">{t("sidebar.generalSettings")}</Link>
          </div>
          <div className='drPic text-center'>
            <img className='mt-2' src={drPicc} alt="" />
            <p>{t("sidebar.welcomeBack")}</p>
          </div>
        </nav>
      </div>
    </>
  );
}

export default SideNavbar;
